import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { EndpointService } from '@app/core';
import { Const } from '@app/shared';

@Injectable()
export class DocsDataService {
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private api: EndpointService
  ) {}

  PATH_SERVICES = Const.ROUTES_SYSTEM_INTEGRATIONS.cinco.services;
  /**
   * Servicio encargado de subir los archivos
   *
   * @param {FormData} formData
   * @returns {Observable<any>}
   * @memberof DocsDataService
   */
  uploadFile(formData: FormData): Observable<any> {
    return new Observable(obs => {
      this.http
        .post(this.api.get('docsInstance'), formData, {
          observe: 'response'
        })
        .subscribe(
          res => {
            if (res.status === 201) {
              obs.next(res.body);
              this.toastr.success('Archivos subidos correctamente.', 'Operación exitosa');
            } else {
              obs.next({});
            }
          },
          err => {
            obs.error(err);
          }
        );
    });
  }

  /**
   * servicio para descargar los archivos
   *
   * @param {number} idDocumento
   * @returns {Observable<any>}
   * @memberof DocsDataService
   */
  dowloadFile(idDocumento: number): Observable<any> {
    return new Observable(obs => {
      this.http
        .skipErrorHandler()
        .get(this.api.get('docsInstance', [idDocumento]), {
          observe: 'response'
        })
        .subscribe(
          res => {
            obs.next(res.body);
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              this.toastr.error(err.error['message'], 'Fallo de descarga');
            }
            obs.error(err);
          }
        );
    });
  }
  downloadFileBlob(url:any): Observable<any>{
    return new Observable(obs =>{
    this.http.get(url,{responseType: 'blob'})
        .subscribe((res)=>{
          let resultDoc = URL.createObjectURL(res);
          obs.next(resultDoc);
          // var a = document.createElement("a");
          // a.href = URL.createObjectURL(res);
          // a.download = fileName;
          // // start download
          // a.click();
        },err => {
          if (err.status !== 401 && err.status !== 403) {
            this.toastr.error(err.error['message'], 'Fallo de descarga');
          }
          obs.error(err);
        })
      });
  }
  

  /**
   * Servicio que genera el documento
   *
   * @param {{tarea: number, documento: number}} data
   * @returns {Observable<any>}
   * @memberof DocsDataService
   */
  generateDocument(data: any): Observable<any> {
    return new Observable(obs => {
      this.http
        .skipErrorHandler()
        .post(this.api.get('documentGeneration'), data, {
          observe: 'response'
        })
        .subscribe(
          res => {
            obs.next(res.body);
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              if (err.error == "Código suminstrado no valido"){
              }else{
                this.toastr.error(err.error['message'], 'Fallo de descarga');
              }
              
            }
            obs.error(err);
          }
        );
    });
  }


    /**
   * Servicio que genera el documento
   *
   * @param {{tarea: number, documento: number}} data
   * @returns {Observable<any>}
   * @memberof DocsDataService
   */
     updateDocument(data: any): Observable<any> {
      return new Observable(obs => {
        this.http
          .skipErrorHandler()
          .post(this.api.get('DocumentUtility'), data, {
            observe: 'response'
          })
          .subscribe(
            res => {
              obs.next(res.body);
            },
            err => {
              if (err.status !== 401 && err.status !== 403) {
                if (err.error == "Código suminstrado no valido"){
                }else{
                  this.toastr.error(err.error['message'], 'Fallo de descarga');
                }
                
              }
              obs.error(err);
            }
          );
      });
    }

  /**
   * Servicio que consulta el solicitante
   *
   * @param {{tarea: number, documento: number}} data
   * @returns {Observable<any>}
   * @memberof DocsDataService
   */
   getUserDocument(task: any): Observable<any> {
    return new Observable(obs => {
      this.http
        .skipErrorHandler()
        .get(this.api.get('MultiUser', [task]), {
          observe: 'response'
        })
        .subscribe(
          res => {
            obs.next(res.body);
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              this.toastr.error(err.error['message'], 'Fallo en la carga de usuarios');
            }
            obs.error(err);
          }
        );
    });
  }

    /**
   * Servicio encargado de consultar los documentos por usuario
   *
   * @param {any} data
   * @returns {Observable<any>}
   * @memberof DocsDataService
   */
     getDocumentUser(data: any): Observable<any> {
      return new Observable(obs => {
        this.http
          .post(this.api.get('MultiUserDocument'), data, {
            observe: 'response'
          })
          .subscribe(
            res => {
              if (res.status === 200) {
                obs.next(res.body);
                // this.toastr.success('Archivos subidos correctamente.', 'Operación exitosa');
              } else {
                obs.next({});
              }
            },
            err => {
              obs.error(err);
            }
          );
      });
    }


    /**
   * Servicio que consulta el codigo para firmar
   *
   * @param {{tarea: number, clasificacion: number,tipo_documental: number,metodo: string}} data
   * @returns {Observable<any>}
   * @memberof DocsDataService
   */
   getCode(data:any): Observable<any> {
    return new Observable(obs => {
      const path = this.PATH_SERVICES + Const.ROUTES_SYSTEM_INTEGRATIONS.cinco.endpoints.DynamicCode;
      this.http
        .skipErrorHandler()
        .post<any>(this.api.addParams(path, 'simple', []), data, {
          observe: 'response'
        })
        .subscribe(
          res => {
            obs.next(res.body);
          },
          err => {
            if (err.status !== 401 && err.status !== 403) {
              this.toastr.error(err.error['message'], 'Fallo en generación de código');
            }
            obs.error(err);
          }
        );
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/forms/shared/docs/shared/docs-data.service.ts